import React from 'react';
import {trackEvent} from '../../utils/tracking.js';
import PropTypes from 'prop-types';
import './style.scss';
import { withGigCardContext } from '../gig_card_context';

const addSpaceToClasses = (classes) => ` ${classes} `,
    Title = ({ gigUrl, caption, classes, cardType, cardSize }) => (
        <a href={gigUrl}
            onClick={() => trackEvent('title', cardType, cardSize)}
            className={`gig-link-main${classes ? addSpaceToClasses(classes) : ''} js-gig-card-imp-data`}
            rel="nofollow"
            title={caption}>
            <h3>{caption}</h3>
        </a>
    );

Title.propTypes = {
    gigUrl: PropTypes.string,
    caption: PropTypes.string,
    cardType: PropTypes.string
};

const contextSelector = ({ cardType, cardSize }) => ({ cardType, cardSize });

export default withGigCardContext(contextSelector)(Title);



// WEBPACK FOOTER //
// ./src/shared/title/index.js